



















import { Component, Vue, Prop } from 'vue-property-decorator';
import { Product } from '@/api';

@Component({})
export default class EscalatedAlertCardUserTab extends Vue {
	@Prop({ type: Object })
	public product!: Product;

	public fields = [
		{
			key: 'name',
			label: 'Name',
		},
		{
			key: 'email',
			label: 'Email',
		},
		{
			key: 'phone',
			label: 'Phone',
		},
	];

	public get getItems() {
		if (this.product?.users) {
			return this.product.users;
		}
		return []
	}
}
